import { action } from 'mobx';
import { QuestionModel } from '@/survey/logic';

export class GraphicSelectModel extends QuestionModel {
  @action
  handleSelectStar = (starNumber: number) => {
    const answerToSelect = this.question.form_answers.find((a) => a.answer_number === starNumber);
    if (!answerToSelect) {
      return;
    }

    // если на звезду нажали повторно, то удаляем ответ, связанный с ней
    this.set_selectedAnswers(answerToSelect === this.selectedAnswers[0] ? [] : [answerToSelect]);
  };
}
